export { default } from "@src/Apps/FreeCourseLicense";
